/** Exchanges the site charts, in menu order. Ids match the HopCharts adapters. */
export interface ExchangeInfo {
  id: string;
  name: string;
  /** Brand colour for the small exchange badge. */
  color: string;
  /** Quote assets offered first in symbol search. */
  quotes: string[];
}

export const EXCHANGES: ExchangeInfo[] = [
  { id: 'binance', name: 'Binance', color: '#F0B90B', quotes: ['USDT', 'USDC', 'FDUSD', 'BTC', 'ETH', 'EUR'] },
  { id: 'coinbase', name: 'Coinbase', color: '#0052FF', quotes: ['USD', 'USDC', 'EUR', 'BTC', 'ETH'] },
  { id: 'kraken', name: 'Kraken', color: '#7B61FF', quotes: ['USD', 'EUR', 'USDT', 'BTC'] },
  { id: 'bybit', name: 'Bybit', color: '#F7A600', quotes: ['USDT', 'USDC', 'BTC'] },
  { id: 'okx', name: 'OKX', color: '#9AA4AE', quotes: ['USDT', 'USDC', 'BTC', 'EUR'] },
  { id: 'bitvavo', name: 'Bitvavo', color: '#0A4DFF', quotes: ['EUR'] },
];

const BY_ID = new Map(EXCHANGES.map((e) => [e.id, e]));

export function exchangeInfo(id: string): ExchangeInfo {
  return BY_ID.get(id) ?? { id, name: id.charAt(0).toUpperCase() + id.slice(1), color: '#5d7a84', quotes: [] };
}

export const DEFAULT_EXCHANGE = 'binance';
export const DEFAULT_PAIR = 'BTC/USDT';
